






























helpers = require('../../helpers.coffee')

view_model = {
  components:
    filters: require('./filters.vue'),
    contactGroupListItem: require('./list_item.vue')

  props:
    contact_groups:
      default: -> []

    view_mode:
      type: Object
      required: true

    filters:
      default: -> {}

    selected_contact_ids:
      default: -> []

    all_initially_selected:
      default: -> false

  data: ->
    selected_all: false

  methods:
    filter: (filters) ->
      @$emit('filter', filters)

    toggleSelectAll: ->
      @selected_all = ! @selected_all
      EventsBus.$emit 'ContactGroupList:SelectedAll', { @selected_all }

    bubbleUp: (data) ->
      if data.event and data.event.originalEventName
        @$emit data.event.originalEventName, data
      else
        console.warn 'bubbleUp method requires data.event.originalEventName to work properly'

  created: ->
    @selected_all = @all_initially_selected
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contact_groups/list.vue